import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'

export class BillingStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  init = async () => {
    const { billingStore } = this._entities

    if (billingStore.billingPlansStore.plans.length === 0) {
      await billingStore.fetchPlans()
    }
  }

  get entities() {
    return this._entities
  }
}
